export default __webpack_public_path__ + "static/media/presentaciones-semanas.31008b09.png";